import React from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import {
    BudgetProposalT,
    CellRendererParams,
    InscriptionWithMetadata,
} from 'routes/BudgetModule/config/types';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { INSCRIPTION_EXPENSE_INCOME } from 'routes/BudgetModule/config/constants';
import {
    getBudgetProposalFromInscription,
    getResourceSoftwareIdFromInscription,
} from 'routes/BudgetModule/shared/entities/inscription';
import { trackEventBudget, TRACKABLE_EVENTS } from 'helpers/trackerHelpers';

const StyBox = styled(Box, {
    name: 'StyBox',
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export type OpenButtonCellRendererParams =
    CellRendererParams<InscriptionWithMetadata> & {
        budgetProposals: BudgetProposalT[];
    };

export default function OpenButtonCellRenderer({
    data,
    budgetProposals,
}: OpenButtonCellRendererParams): React.ReactElement {
    if (!data) {
        return <span />;
    }

    const { inscription } = data;

    const budgetProposal = getBudgetProposalFromInscription(
        inscription,
        budgetProposals,
    );
    const resourceSoftwareId = getResourceSoftwareIdFromInscription(
        inscription,
        budgetProposal,
    );
    const expenseIncome = inscription[INSCRIPTION_EXPENSE_INCOME];
    if (!resourceSoftwareId || !expenseIncome) return <></>;
    const inscriptionLink = `/budget_proposal/${
        budgetProposal?.id
    }/resource/${encodeURIComponent(resourceSoftwareId)}/${expenseIncome.toLowerCase()}/imputations`;

    return (
        <StyBox>
            <IconButton
                color="primary"
                component={Link}
                style={{ padding: '0px' }}
                to={inscriptionLink}
                onClick={() => {
                    // If this cell renderer is ever used for something else than AllInscriptions,
                    // make sure to change this tracking event to account for that.
                    trackEventBudget(
                        TRACKABLE_EVENTS.budget.budgetOverview.inscriptions
                            .expenseIncomeNewTab,
                        { openedPage: inscriptionLink },
                    );
                }}
                target="_blank"
                size="large"
            >
                <OpenInNewIcon />
            </IconButton>
        </StyBox>
    );
}
